import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { WindowService } from '../../services/window-dialogs/window.service';
import { SortBot } from '../../helpers/sort';
import * as moment from 'moment';
import { Message, SelectItem } from 'primeng/primeng';
import { AdminPermissionTypes } from '@models/domain/admin.permission.item';
import { AdminItemArray } from '@models/domain/admin.item';
import { GlobalAdminBrowseLogsRequest } from '@models/ss-api/requests/global.admin.browse.logs.request';
import { AdminBrowseLogItemArray } from '@models/ss-api/responses/admin.browse.logs.response';
import { LicenseManager } from 'app/managers/License.manager';
import { GetAttendanceTrackingRequest } from '@models/ss-api/requests/get.attendance.tracking.request';
import { TrainingAttendanceArray } from '@models/domain/training.attendance';
import { TrainingClassArray } from '@models/domain/training.class';

@Component({
    selector: 'training-attendance',
    templateUrl: './training.attendance.component.html',
    styleUrls: ['./training.attendance.component.scss']
})
export class TrainingAttendanceComponent implements OnInit {

    // VARIABLES
    IsBusy: boolean = false;

    TrainingAttendanceRecords = new TrainingAttendanceArray();


    AdminOptions: SelectItem[];
    SelectedAdmin : SelectItem;
    SelectedAdminID : number = null;

    ClassOptions: SelectItem[];
    SelectedClass : SelectItem;
    SelectedClassID : number = null;

    TotalEnrolled : number = 0;
    TotalAttended : number = 0;

    _today = moment();

    EndDate: Date = moment(this._today).toDate();
    StartDate : Date = moment(this._today).subtract(2, 'weeks').toDate();
 
    constructor(private dialogService: DialogService, private api: ssApiService, private gb: GlobalService, private windowService: WindowService) { }

    ngOnInit() {
        
        this.gb.SetPageTitle('Training Attendance');
        
        this.InitAdminOptions();
        this.InitClasses();
        this.GetAttendance();

    }

    

    GetAttendance() {

        this.TotalAttended = 0;
        this.TotalEnrolled = 0;

        let request = new GetAttendanceTrackingRequest();
        request.StartDate = this.StartDate;
        request.EndDate = this.EndDate;
        request.TrainerID = this.SelectedAdminID;
        request.ClassID = this.SelectedClassID;

        this.IsBusy = true;

        let disposable = this.api.GetAttendanceTracking( request ).subscribe( result => {
            disposable.unsubscribe();
            this.IsBusy = false;
            
            result.Data.forEach(a => this.TotalAttended += a.CountAttended);
            result.Data.forEach(a => this.TotalEnrolled += a.CountEnrolled);
            console.log(result.Data);
            this.TrainingAttendanceRecords = result.Data;

        });
    
    }


    InitAdminOptions() {
        this.AdminOptions = [];
    
        //this.IsBusy = true;
    
        let disposable = this.api.AdminsByPermissionType( AdminPermissionTypes.IsTrainer ).subscribe(response => {
            disposable.unsubscribe();
    
            response.Data = SortBot.SortAuto<AdminItemArray>(response.Data, 'FirstName');
    
            //this.IsBusy = false;
            
            this.AdminOptions.push({ label : 'All Trainers', value : null });

            response.Data.forEach(admin => {
                this.AdminOptions.push({ label: admin.FirstName + ' ' + admin.LastName, value: admin.AdminID });
            });

            this.SelectedAdmin = this.AdminOptions[0];

        });
    

    }

    InitClasses() {
        this.ClassOptions = [];
    
        //this.IsBusy = true;
    
        let disposable = this.api.GetAdminTrainingClasses().subscribe(response => {
            disposable.unsubscribe();
    
            response.Data = SortBot.SortAuto<TrainingClassArray>(response.Data, 'ClassName');
    
            //this.IsBusy = false;
            
            this.ClassOptions.push({ label : 'All Classes', value : null });

            response.Data.forEach(trainingClass => {
                this.ClassOptions.push({ label: trainingClass.ClassName, value: trainingClass.ID });
            });

            this.SelectedClass = this.ClassOptions[0];

        });
    

    }
}
